import { render, staticRenderFns } from "./TextPay.vue?vue&type=template&id=e8a7bbd6&"
import script from "./TextPay.vue?vue&type=script&lang=js&"
export * from "./TextPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports